import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MediaGallery from "./pages/MediaGallery";
import AllBookings from "./pages/AllBookings";
import Reviews from "./pages/Reviews";
import Payment from "./pages/Payment";
import RoomManagement from "./pages/RoomManagement";
import BookingCalendar from "./pages/BookingCalendar";
import PublicBooking from "./pages/PublicBooking";
import BookingConfirmation from "./pages/BookingConfirmation";
import Settings from "./pages/Settings";
import MealPricing from "./pages/MealPricing";
import Layout from "./components/Layout";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Protected Route Component
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const adminId = localStorage.getItem('admin_id');
    setIsAuthenticated(!!adminId);
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes - Customer Website */}
          <Route path="/" element={<PublicBooking />} />
          <Route path="/book" element={<PublicBooking />} />
          <Route path="/booking-confirmation/:bookingId" element={<BookingConfirmation />} />
          
          {/* Admin Routes */}
          <Route path="/login" element={<Login />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="media" element={<MediaGallery />} />
            <Route path="bookings" element={<AllBookings />} />
            <Route path="calendar" element={<BookingCalendar />} />
            <Route path="rooms" element={<RoomManagement />} />
            <Route path="meal-pricing" element={<MealPricing />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="payment" element={<Payment />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
